//change img pc, sp
$(function(){
	var $setElem = $('.switch'),
	pcName = 'pc_',
	spName = 'sp_',
	replaceWidth = 769;

	$setElem.each(function(){
		var $this = $(this);
		function imgSize(){
			var windowWidth = window.innerWidth;
			if(windowWidth >= replaceWidth) {
				$this.attr('src',$this.attr('src').replace(spName,pcName)).css({visibility:'visible'});
			} else if(windowWidth < replaceWidth) {
				$this.attr('src',$this.attr('src').replace(pcName,spName)).css({visibility:'visible'});
			}
		}
		$(window).resize(function(){imgSize();});
		imgSize();
	});
});

// anchor link
$(function(){
		$('a[href^="#"]').click(function(){
			var speed = 400;
			var hh = $('.flex_h').outerHeight();
			if (  $(this).attr('href').length > 1) {
				var p = $( $(this).attr('href') ).offset();
				if (window.matchMedia("(max-width: 768px)").matches) {
					$("html, body").animate({scrollTop:p.top - hh}, speed, "swing");
				}else{
					$("html, body").animate({scrollTop:p.top}, speed, "swing");
				}
			}
			return false;
		});
});

// totop
$(document).ready(function() {
  	var pagetop = $('.pagetop');
    $(window).scroll(function () {
       	if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
       	} else {
            pagetop.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body, html').animate({ scrollTop: 0 }, 500);
        return false;
   	});
});

// slider only sp
$(document).ready(function() {
	if (window.matchMedia("(max-width: 768px)").matches) {
		$('.list_star').slick({
	    	slidesToShow: 1,
	     	slidesToScroll: 1,
	     	autoplay: true,
	     	autoplaySpeed: 2000
	  	});
  	};
});